import type { Dispatch } from 'redux';
import { Role } from './roleTypes';
import { RbacCommHandler } from '../../utils';
import { setIsSuperadmin } from './roleSlice';
import checkSuperadminStatus from '../../utils/checkSuperAdmin';
import { getAuthHeader } from '../../utils/utils';

const fetchRoles = async (dispatch: Dispatch): Promise<Role[]> => {
  const email = localStorage.getItem('user');
  const token = localStorage.getItem('token');
  if (!email) {
    return Promise.reject(new Error('Email not found'));
  }
  if (!token) {
    return Promise.reject(new Error('Token not found'));
  }

  try {
    const response = await RbacCommHandler.request({
      url: '/role/user-role',
      method: 'GET',
      headers: getAuthHeader,
    });

    let roles: Role[] = [];
    if (Array.isArray(response)) {
      roles = response;
    } else if (Array.isArray(response?.data)) {
      roles = response.data;
    }
    const isUserSuperadmin = await checkSuperadminStatus(email);
    dispatch(setIsSuperadmin(isUserSuperadmin));

    return roles;
  } catch (error) {
    console.error('Error fetching roles:', error);
    return Promise.reject(new Error('Error fetching roles'));
  }
};

export default fetchRoles;
